export const getEnvironmentLowerCased = () => {
  let ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
  if (ENVIRONMENT != null) {
    ENVIRONMENT = ENVIRONMENT.toLowerCase();
  }

  return ENVIRONMENT;
};
